import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-20 bg-[#1A5C4C] text-white relative overflow-hidden" data-id="element-114">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full mix-blend-overlay translate-x-1/2 -translate-y-1/2" data-id="element-115"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C97B63] opacity-20 rounded-full mix-blend-overlay -translate-x-1/3 translate-y-1/3" data-id="element-116"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-117">
        <FadeIn data-id="element-118">
          <div className="text-center mb-12" data-id="element-119">
            <span className="text-[#C97B63] font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-120">
              El Secreto Revelado
            </span>
            <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-121">
              La solución se llama <br data-id="element-122" />
              <span className="text-[#FDF6F0]" data-id="element-123">
                Ciclado de Carbohidratos Hormonal (3:1)
              </span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-124">
          <div className="bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-2xl border border-white/20" data-id="element-125">
            <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-126">
              En lugar de eliminar los carbohidratos, aprendemos a "ciclarlo"
              para engañar al metabolismo.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-127">
              <div className="border-l-2 border-[#C97B63] pl-6" data-id="element-128">
                <h4 className="font-serif text-2xl text-[#C97B63] mb-2" data-id="element-129">
                  Días 1 a 3
                </h4>
                <p className="text-white/90" data-id="element-130">
                  Enseñamos a tus células a quemar grasa acumulada como
                  combustible principal.
                </p>
              </div>
              <div className="border-l-2 border-[#E8F0E8] pl-6" data-id="element-131">
                <h4 className="font-serif text-2xl text-[#E8F0E8] mb-2" data-id="element-132">
                  Día 4
                </h4>
                <p className="text-white/90" data-id="element-133">
                  Reintroducimos carbohidratos específicos que le dicen a tu
                  tiroides: "Estamos a salvo, puedes seguir quemando".
                </p>
              </div>
            </div>
            <p className="text-xl font-serif italic text-center mt-10 text-[#FDF6F0]" data-id="element-134">
              Es la única forma de bajar de peso sin que tu cuerpo entre en modo
              de pánico.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}